import { takeEvery, takeLatest } from 'redux-saga/effects';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import {
  CREATE_APPLICATION,
  DELETE_APPLICATION,
  LOAD_APPLICATION_BY_ID,
  LOAD_LIST,
  ARCHIVE_APPLICATION,
  UNARCHIVE_APPLICATION,
  LOAD_APPLICATION_STATUS,
  LOAD_APPLICATION_HISTORY,
  LOAD_AWAIT_DOCUMENT,
  LOAD_DOCUMENT_BY_ID,
  DELETE_DOCUMENT,
  GROUP_SIGN_FILE,
  GROUP_DELETE_FILE,
  UN_ASSIGN_APPLICATION_BY_ID,
  GENERATE_DOCX,
  APPLICATION_FIELDS_VALIDATION,
  RESTORE_APPLICATION,
  IMPORT,
  EDIT_APPLICATION_BY_ID,
  GROUP_SIGN_APPLICATION,
  ASSIGN_APPLICATION_BY_ID,
  SIGN_APPLICATION,
  VERIFY_SIGNATURE,
  LOAD_LEGAL_ENTITY_FORM_LIST,
} from '../actions';

import loadApplicationList from './loadApplicationList';
import createApplication from './createApplication';
import loadApplicationById from './loadApplicationById';
import deleteApplication from './deleteApplication';
import restoreApplication from './restoreApplication';
import archiveApplication from './archiveApplication';
import unarchiveApplication from './unarchiveApplication';
import loadApplicationStatus from './loadApplicationStatus';
import loadApplicationHistory from './loadApplicationHistory';
import loadAwaitDocument from './loadAwaitDocument';
import loadDocumentById from './loadDocumentById';
import deleteDocument from './deleteDocument';
import groupSignFile from './groupSignFile';
import groupDeleteFile from './groupDeleteFile';
import unAssignApplicationById from './unAssignApplicationById';
import generateDocx from './generateDocx';
import applicationFieldsValidation from './applicationFieldsValidation';
import importApplication from './importApplication';
import editApplicationById from './editApplicationById';
import groupSignApplication from './groupSignApplication';
import assignApplicationById from './assignApplicationById';
import signApplication from './signApplication';
import verifySignature from './verifySignature';
import loadLegalEntityFormList from './loadLegalEntityFormList';

export default function* watchDashboard() {
  yield takeLatest(APPLICATION_MODULE + LOAD_LIST, loadApplicationList);
  yield takeLatest(APPLICATION_MODULE + CREATE_APPLICATION, createApplication);
  yield takeEvery(APPLICATION_MODULE + EDIT_APPLICATION_BY_ID, editApplicationById);
  yield takeEvery(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID, loadApplicationById);
  yield takeEvery(APPLICATION_MODULE + DELETE_APPLICATION, deleteApplication);
  yield takeEvery(APPLICATION_MODULE + RESTORE_APPLICATION, restoreApplication);
  yield takeEvery(APPLICATION_MODULE + ARCHIVE_APPLICATION, archiveApplication);
  yield takeEvery(APPLICATION_MODULE + UNARCHIVE_APPLICATION, unarchiveApplication);
  yield takeLatest(APPLICATION_MODULE + LOAD_APPLICATION_STATUS, loadApplicationStatus);
  yield takeLatest(APPLICATION_MODULE + LOAD_APPLICATION_HISTORY, loadApplicationHistory);
  yield takeLatest(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT, loadAwaitDocument);
  yield takeEvery(APPLICATION_MODULE + LOAD_DOCUMENT_BY_ID, loadDocumentById);
  yield takeEvery(APPLICATION_MODULE + DELETE_DOCUMENT, deleteDocument);
  yield takeEvery(APPLICATION_MODULE + GROUP_SIGN_FILE, groupSignFile);
  yield takeEvery(APPLICATION_MODULE + GROUP_DELETE_FILE, groupDeleteFile);
  yield takeEvery(APPLICATION_MODULE + UN_ASSIGN_APPLICATION_BY_ID, unAssignApplicationById);
  yield takeEvery(APPLICATION_MODULE + GENERATE_DOCX, generateDocx);
  yield takeEvery(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION, applicationFieldsValidation);
  yield takeEvery(APPLICATION_MODULE + IMPORT, importApplication);
  yield takeEvery(APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID, assignApplicationById);
  yield takeEvery(APPLICATION_MODULE + GROUP_SIGN_APPLICATION, groupSignApplication);
  yield takeEvery(APPLICATION_MODULE + SIGN_APPLICATION, signApplication);
  yield takeEvery(APPLICATION_MODULE + VERIFY_SIGNATURE, verifySignature);
  yield takeLatest(APPLICATION_MODULE + LOAD_LEGAL_ENTITY_FORM_LIST, loadLegalEntityFormList);
}
